<template>
	<div class="item">
		<v-textarea
			browser-autocomplete="off"
			:disabled="disabled"
			:label=label
			:error-messages="errorMessages"
			:rules="[rules.validate]"
			:value=editedValue
			data-vv-scope="scope1"
			validate-on-blur
			@change="save"
			rows=1
			class="no-print"
			auto-grow
			aria-label="label for text">
		</v-textarea>
		<div class="div-for-print"><p><strong style="font-size: 12px">{{label}}</strong></p>{{editedValue}}</div>
	</div>
</template>

<script>
	export default {
		name: "CostsTextInputField",

		data() {
			return {
				editedValue: "",
				errorMessages: "",
				rules: {
					validate: function (value) {
						return !!value || "to pole jest wymagane.";
					},
				},
			};
		},
		methods: {
			save(val) {
				this.editedValue = val;
				this.$emit("input", val);
				this.$emit("update:valid", this.rules.validate(val) === true);
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.editedValue = val;
					this.$emit("update:valid", this.rules.validate(val) === true);
				},
			},
		},


		props: {
			value: String,
			label: String,
			valid: Boolean,
			disabled: {default: false}
		},
	};
</script>

<style scoped>
	.item {
		margin: 0px;
	}
</style>
